import Vue from 'vue'

Vue.component('TrackedLink', require('../components/nav/tracked-link').default)

Vue.component('Icon', require('../components/shared/icons/icon').default)

Vue.component(
    'TransitionFade',
    require('../components/shared/transitions/transition-fade').default
)

Vue.component(
    'TheModalWrapper',
    require('../components/modals/the-modal-wrapper').default
)

Vue.component(
    'Clearspace',
    require('../components/shared/container/clearspace').default
)

Vue.component(
    'PlatformUsps',
    require('../components/shared/usps/platform-usps').default
)

Vue.component('OcTag', require('../../shared/components/oc-tag.vue').default)

// Eager load some components:
Vue.component(
    'ModalSignup',
    require('../components/modals/marketplace/ModalSignup.vue').default
)
